export default __webpack_public_path__ + "static/media/academics-base-mobile.3432dc7c.jpg";